
import {Application} from '@app/views/admin/application-settings/models/application.model';

export class AuditUserActivity {
    userActionGuid: string;
    orgGuid: string;
    userEmail: string;
    objectId?: string;
    actionName: AuditUserActivityActions;
    httpPath?: string;
    parameters?: string;
    parametersList?: AuditUserActivityParameter[];
    executedAt: Date;
    clientIpAddress?: string;
    serverIpAddress?: string;
    isFirstListItemInADay: boolean;
    application: Application;
    view: AuditUserActivityView;
}

export class AuditUserActivityParameter {
    constructor(
        public name: string,
        public value: string
    ) {
    }
}

export class AuditUserActivityView {
    constructor(
        public orgLink?: AuditUserActivityViewLink,
        public userInitiatorLink?: AuditUserActivityViewLink,
        public userObjectIdLink?: AuditUserActivityViewLink,
        public appLink?: AuditUserActivityViewLink,
        public objectIdOtherText?: AuditUserActivityViewLink,
    ) {
    }
}

export class AuditUserActivityViewLink {
    constructor(
        public title: string,
        public routerLink: string,
        public page: AuditUserActivityPagesList,
        public showInListView: boolean,
        public value?: string
    ) {
    }
}

export enum AuditUserActivityActions {
    SEND_REQUEST_WITH_INTEGRATION = 'SEND_REQUEST_WITH_INTEGRATION',
    APPROVE_REQUEST = 'APPROVE_REQUEST',
    REJECT_REQUEST = 'REJECT_REQUEST',
    DELETE_REQUEST = 'DELETE_REQUEST',
    SAVE_EXPIRATION_DATE = 'SAVE_EXPIRATION_DATE',
    CREATE_OR_UPDATE_APPLICATION = 'CREATE_OR_UPDATE_APPLICATION',
    DELETE_APPLICATION = 'DELETE_APPLICATION',
    PUBLISH_UNPUBLISH_APPLICATION = 'PUBLISH_UNPUBLISH_APPLICATION',
    SAVE_INTEGRATION_RULES = 'SAVE_INTEGRATION_RULES',
    SAVE_INTEGRATION_PROCESS_CONFIG = 'SAVE_INTEGRATION_PROCESS_CONFIG',
    SAVE_DICTIONARY_BY_NAME = 'SAVE_DICTIONARY_BY_NAME',
    SAVE_QWIKLABS_DICTIONARY = 'SAVE_QWIKLABS_DICTIONARY',
    SAVE_APP_LINK_DICTIONARIES = 'SAVE_APP_LINK_DICTIONARIES',
    RUN_SYNC = 'RUN_SYNC',
    SUSPEND_SYNC = 'SUSPEND_SYNC',
    UNSUSPEND_SYNC = 'UNSUSPEND_SYNC',
    ACTIVATE_DISTRICT_FEATURE_TOGGLES = 'ACTIVATE_DISTRICT_FEATURE_TOGGLES',
    ACTIVATE_APPLICATION_FEATURE_TOGGLES = 'ACTIVATE_APPLICATION_FEATURE_TOGGLES',
    ACTIVATE_INTEGRATION_FEATURE_TOGGLES = 'ACTIVATE_INTEGRATION_FEATURE_TOGGLES',
    CREATE_ORGANIZATION = 'CREATE_ORGANIZATION',
    EDIT_ORGANIZATION = 'EDIT_ORGANIZATION',
    DELETE_ORGANIZATION = 'DELETE_ORGANIZATION',
    ADD_ORGANIZATION_ADMIN = 'ADD_ORGANIZATION_ADMIN',
    EDIT_ORGANIZATION_ADMINS = 'EDIT_ORGANIZATION_ADMINS',
    DELETE_ORGANIZATION_ADMIN = 'DELETE_ORGANIZATION_ADMIN',
    DISABLE_MFA = 'DISABLE_MFA',
    DISABLE_TOTP_MFA = 'DISABLE_TOTP_MFA',
    CREATE_INTEGRATION = 'CREATE_INTEGRATION',
    CREATE_INTEGRATION_PENDING = 'CREATE_INTEGRATION_PENDING',
    SAVE_INTEGRATION_TASK = 'SAVE_INTEGRATION_TASK',
    EDIT_INTEGRATION_TASK = 'EDIT_INTEGRATION_TASK',
    DELETE_INTEGRATION_TASK = 'DELETE_INTEGRATION_TASK',
    SAVE_INTEGRATION_ORG_MAPPING = 'SAVE_INTEGRATION_ORG_MAPPING',
    DELETE_INTEGRATION_ORG_MAPPING = 'DELETE_INTEGRATION_ORG_MAPPING',
    BULK_DELETE_INTEGRATION_ORGS_MAPPING = 'BULK_DELETE_INTEGRATION_ORGS_MAPPING',
    CREATE_OR_UPDATE_FTP_USER = 'CREATE_OR_UPDATE_FTP_USER',
    DELETE_FTP_USER = 'DELETE_FTP_USER',
    CREATE_DATA_SOURCE_CONFIG = 'CREATE_DATA_SOURCE_CONFIG',
    GENERATE_SECRET_KEY_SFTP = 'GENERATE_SECRET_KEY_SFTP',
    GENERATE_KEYS_LTI = 'GENERATE_KEYS_LTI',
    UPDATE_DATA_SOURCE_CONFIG = 'UPDATE_DATA_SOURCE_CONFIG',
    SAVE_MAPPING_RULES_ARCHIVE_OU = 'SAVE_MAPPING_RULES_ARCHIVE_OU',
    CREATE_SHARED_POOL = 'CREATE_SHARED_POOL',
    APPLICATION_INSTITUTION_CREDENTIALS = 'APPLICATION_INSTITUTION_CREDENTIALS',
    ONBOARDING_INSTITUTION_CREDENTIALS = 'ONBOARDING_INSTITUTION_CREDENTIALS',
    ONBOARDING_REGENERATE_INSTITUTION_CREDENTIALS = 'ONBOARDING_REGENERATE_INSTITUTION_CREDENTIALS',
    SHARED_POOL_INSTITUTION_CREDENTIALS = 'SHARED_POOL_INSTITUTION_CREDENTIALS',
    AUTH_API_TOKEN_SUCCESS = 'AUTH_API_TOKEN_SUCCESS',
    AUTH_API_TOKEN_EXCEEDED_FAILED_ATTEMPTS = 'AUTH_API_TOKEN_EXCEEDED_FAILED_ATTEMPTS',
    AUTH_API_TOKEN_CLIENT_NOT_FOUND = 'AUTH_API_TOKEN_CLIENT_NOT_FOUND',
    AUTH_API_TOKEN_BAD_CREDENTIAL = 'AUTH_API_TOKEN_BAD_CREDENTIAL',
    AUTH_LOGIN_SUCCESS = 'AUTH_LOGIN_SUCCESS',
    AUTH_LOGIN_FAIL_BAD_USERNAME = 'AUTH_LOGIN_FAIL_BAD_USERNAME',
    AUTH_LOGIN_FAIL_BAD_CREDENTIAL = 'AUTH_LOGIN_FAIL_BAD_CREDENTIAL',
    AUTH_LOGIN_FROM_ETX = 'AUTH_LOGIN_FROM_ETX',
    USER_CHANGE_PASSWORD = 'USER_CHANGE_PASSWORD',
    SEND_LINK_FOR_RESET_PASSWORD = 'SEND_LINK_FOR_RESET_PASSWORD',
    MFA_REGENERATE_RESET_CODES = 'MFA_REGENERATE_RESET_CODES'
}

export enum AuditUserActivityActionObjectIdList {
    INTEGRATION_ID = 'integrationId',
    APPLICATION_GUID = 'applicationGuid',
    DNAME = 'dname',
    USER_GUID = 'userGuid',
    ORGANIZATION_GUID = 'organizationGuid',
    DISTRICT_GUID = 'districtGuid',
    EMAIL = 'email',
    CLIENT_ID = 'Client Id',
    USERNAME = 'username',
    INSTITUTION_AND_APPLICATION_GUID = 'institution and applicationGuid',
    NULL = 'null',
}

export const AuditUserActivityActionObjectIdTitleList = {
    integrationId: 'Integration Id',
    requestGuid: 'Request guid',
    applicationGuid: 'Application guid',
    dname: 'Dname',
    userGuid: 'User guid',
    organizationGuid: 'Organization guid',
    districtGuid: 'District guid',
    email: 'Email',
    clientId: 'Client Id',
    username: 'Username',
    ['institution and applicationGuid']: 'Application guid',
    null: 'null',
};

export const AuditUserActivityActionObjectIdMap = {
    [AuditUserActivityActions.SEND_REQUEST_WITH_INTEGRATION]: AuditUserActivityActionObjectIdList.INTEGRATION_ID,
    [AuditUserActivityActions.APPROVE_REQUEST]: AuditUserActivityActionObjectIdList.INTEGRATION_ID,
    [AuditUserActivityActions.REJECT_REQUEST]: AuditUserActivityActionObjectIdList.INTEGRATION_ID,
    [AuditUserActivityActions.DELETE_REQUEST]: AuditUserActivityActionObjectIdList.INTEGRATION_ID,
    [AuditUserActivityActions.SAVE_EXPIRATION_DATE]: AuditUserActivityActionObjectIdList.INTEGRATION_ID,
    [AuditUserActivityActions.CREATE_OR_UPDATE_APPLICATION]: AuditUserActivityActionObjectIdList.APPLICATION_GUID,
    [AuditUserActivityActions.DELETE_APPLICATION]: AuditUserActivityActionObjectIdList.APPLICATION_GUID,
    [AuditUserActivityActions.PUBLISH_UNPUBLISH_APPLICATION]: AuditUserActivityActionObjectIdList.APPLICATION_GUID,
    [AuditUserActivityActions.SAVE_INTEGRATION_RULES]: AuditUserActivityActionObjectIdList.INTEGRATION_ID,
    [AuditUserActivityActions.SAVE_INTEGRATION_PROCESS_CONFIG]: AuditUserActivityActionObjectIdList.INTEGRATION_ID,
    [AuditUserActivityActions.SAVE_DICTIONARY_BY_NAME]: AuditUserActivityActionObjectIdList.INTEGRATION_ID,
    [AuditUserActivityActions.SAVE_QWIKLABS_DICTIONARY]: AuditUserActivityActionObjectIdList.DNAME,
    [AuditUserActivityActions.SAVE_APP_LINK_DICTIONARIES]: AuditUserActivityActionObjectIdList.DNAME,
    [AuditUserActivityActions.RUN_SYNC]: AuditUserActivityActionObjectIdList.INTEGRATION_ID,
    [AuditUserActivityActions.SUSPEND_SYNC]: AuditUserActivityActionObjectIdList.INTEGRATION_ID,
    [AuditUserActivityActions.UNSUSPEND_SYNC]: AuditUserActivityActionObjectIdList.INTEGRATION_ID,
    [AuditUserActivityActions.ACTIVATE_DISTRICT_FEATURE_TOGGLES]: AuditUserActivityActionObjectIdList.ORGANIZATION_GUID,
    [AuditUserActivityActions.ACTIVATE_APPLICATION_FEATURE_TOGGLES]: AuditUserActivityActionObjectIdList.APPLICATION_GUID,
    [AuditUserActivityActions.ACTIVATE_INTEGRATION_FEATURE_TOGGLES]: AuditUserActivityActionObjectIdList.INTEGRATION_ID,
    [AuditUserActivityActions.CREATE_ORGANIZATION]: AuditUserActivityActionObjectIdList.ORGANIZATION_GUID,
    [AuditUserActivityActions.EDIT_ORGANIZATION]: AuditUserActivityActionObjectIdList.ORGANIZATION_GUID,
    [AuditUserActivityActions.DELETE_ORGANIZATION]: AuditUserActivityActionObjectIdList.ORGANIZATION_GUID,
    [AuditUserActivityActions.ADD_ORGANIZATION_ADMIN]: AuditUserActivityActionObjectIdList.USER_GUID,
    [AuditUserActivityActions.EDIT_ORGANIZATION_ADMINS]: AuditUserActivityActionObjectIdList.USER_GUID,
    [AuditUserActivityActions.DELETE_ORGANIZATION_ADMIN]: AuditUserActivityActionObjectIdList.USER_GUID,
    [AuditUserActivityActions.DISABLE_MFA]: AuditUserActivityActionObjectIdList.USER_GUID,
    [AuditUserActivityActions.DISABLE_TOTP_MFA]: AuditUserActivityActionObjectIdList.USER_GUID,
    [AuditUserActivityActions.CREATE_INTEGRATION]: AuditUserActivityActionObjectIdList.INTEGRATION_ID,
    [AuditUserActivityActions.CREATE_INTEGRATION_PENDING]: AuditUserActivityActionObjectIdList.INTEGRATION_ID,
    [AuditUserActivityActions.SAVE_INTEGRATION_TASK]: AuditUserActivityActionObjectIdList.INTEGRATION_ID,
    [AuditUserActivityActions.EDIT_INTEGRATION_TASK]: AuditUserActivityActionObjectIdList.INTEGRATION_ID,
    [AuditUserActivityActions.DELETE_INTEGRATION_TASK]: AuditUserActivityActionObjectIdList.INTEGRATION_ID,
    [AuditUserActivityActions.SAVE_INTEGRATION_ORG_MAPPING]: AuditUserActivityActionObjectIdList.INTEGRATION_ID,
    [AuditUserActivityActions.DELETE_INTEGRATION_ORG_MAPPING]: AuditUserActivityActionObjectIdList.INTEGRATION_ID,
    [AuditUserActivityActions.BULK_DELETE_INTEGRATION_ORGS_MAPPING]: AuditUserActivityActionObjectIdList.INTEGRATION_ID,
    [AuditUserActivityActions.CREATE_OR_UPDATE_FTP_USER]: AuditUserActivityActionObjectIdList.USERNAME,
    [AuditUserActivityActions.DELETE_FTP_USER]: AuditUserActivityActionObjectIdList.USERNAME,
    [AuditUserActivityActions.CREATE_DATA_SOURCE_CONFIG]: AuditUserActivityActionObjectIdList.DNAME,
    [AuditUserActivityActions.GENERATE_SECRET_KEY_SFTP]: AuditUserActivityActionObjectIdList.DNAME,
    [AuditUserActivityActions.GENERATE_KEYS_LTI]: AuditUserActivityActionObjectIdList.DNAME,
    [AuditUserActivityActions.UPDATE_DATA_SOURCE_CONFIG]: AuditUserActivityActionObjectIdList.DNAME,
    [AuditUserActivityActions.SAVE_MAPPING_RULES_ARCHIVE_OU]: AuditUserActivityActionObjectIdList.DNAME,
    [AuditUserActivityActions.CREATE_SHARED_POOL]: AuditUserActivityActionObjectIdList.APPLICATION_GUID,
    [AuditUserActivityActions.APPLICATION_INSTITUTION_CREDENTIALS]: AuditUserActivityActionObjectIdList.INSTITUTION_AND_APPLICATION_GUID,
    [AuditUserActivityActions.ONBOARDING_INSTITUTION_CREDENTIALS]: AuditUserActivityActionObjectIdList.APPLICATION_GUID,
    [AuditUserActivityActions.ONBOARDING_REGENERATE_INSTITUTION_CREDENTIALS]: AuditUserActivityActionObjectIdList.APPLICATION_GUID,
    [AuditUserActivityActions.SHARED_POOL_INSTITUTION_CREDENTIALS]: AuditUserActivityActionObjectIdList.APPLICATION_GUID,
    [AuditUserActivityActions.AUTH_API_TOKEN_SUCCESS]: AuditUserActivityActionObjectIdList.INSTITUTION_AND_APPLICATION_GUID,
    [AuditUserActivityActions.AUTH_API_TOKEN_EXCEEDED_FAILED_ATTEMPTS]: AuditUserActivityActionObjectIdList.INSTITUTION_AND_APPLICATION_GUID,
    [AuditUserActivityActions.AUTH_API_TOKEN_CLIENT_NOT_FOUND]: AuditUserActivityActionObjectIdList.CLIENT_ID,
    [AuditUserActivityActions.AUTH_API_TOKEN_BAD_CREDENTIAL]: AuditUserActivityActionObjectIdList.INSTITUTION_AND_APPLICATION_GUID,
    [AuditUserActivityActions.AUTH_LOGIN_SUCCESS]: AuditUserActivityActionObjectIdList.EMAIL,
    [AuditUserActivityActions.AUTH_LOGIN_FAIL_BAD_USERNAME]: AuditUserActivityActionObjectIdList.EMAIL,
    [AuditUserActivityActions.AUTH_LOGIN_FAIL_BAD_CREDENTIAL]: AuditUserActivityActionObjectIdList.EMAIL,
    [AuditUserActivityActions.AUTH_LOGIN_FROM_ETX]: AuditUserActivityActionObjectIdList.NULL,
    [AuditUserActivityActions.USER_CHANGE_PASSWORD]: AuditUserActivityActionObjectIdList.EMAIL,
    [AuditUserActivityActions.SEND_LINK_FOR_RESET_PASSWORD]: AuditUserActivityActionObjectIdList.EMAIL,
    [AuditUserActivityActions.MFA_REGENERATE_RESET_CODES]: AuditUserActivityActionObjectIdList.NULL
};

export enum AuditUserActivityActionFriendlyNames {
    SEND_REQUEST_WITH_INTEGRATION = 'sent data access consent',
    APPROVE_REQUEST = 'approved data access consent',
    REJECT_REQUEST = 'rejected data access consent',
    DELETE_REQUEST = 'deleted data access consent',
    SAVE_EXPIRATION_DATE = 'modified expiration time',
    CREATE_OR_UPDATE_APPLICATION = 'created or updated application',
    DELETE_APPLICATION = 'deleted application',
    PUBLISH_UNPUBLISH_APPLICATION = 'published or unpublished application',
    SAVE_INTEGRATION_RULES = 'modified data requirements or filter rules, or specific app`s settings (mapping rules or login credentials)',
    SAVE_INTEGRATION_PROCESS_CONFIG = 'modified Sync Schedule',
    SAVE_DICTIONARY_BY_NAME = 'modified specific application mappings',
    SAVE_QWIKLABS_DICTIONARY = 'modified Qwiklabs courses and/or classes mappings',
    SAVE_APP_LINK_DICTIONARIES = 'saved SSO applications',
    RUN_SYNC = 'run sync',
    SUSPEND_SYNC = 'suspended sync',
    UNSUSPEND_SYNC = 'resumed sync',
    ACTIVATE_DISTRICT_FEATURE_TOGGLES = 'modified district Advanced Settings ',
    ACTIVATE_APPLICATION_FEATURE_TOGGLES = 'modified application Advanced Settings',
    ACTIVATE_INTEGRATION_FEATURE_TOGGLES = 'modified application Advanced Settings',
    CREATE_ORGANIZATION = 'created ',
    EDIT_ORGANIZATION = 'modified ',
    DELETE_ORGANIZATION = 'deleted ',
    ADD_ORGANIZATION_ADMIN = 'created ', // John.Smith@org.com admin account in Washington district (district / vendor)
    EDIT_ORGANIZATION_ADMINS = 'modified ', // John.Smith@org.com admin account in Washington district (district / vendor)
    DELETE_ORGANIZATION_ADMIN = 'deleted ', // John.Smith@org.com admin account in Washington district (district / vendor)
    DISABLE_MFA = 'SMS MFA deactivated ',
    DISABLE_TOTP_MFA = 'TOTP MFA deactivated ',
    CREATE_INTEGRATION = 'set up initial application configuration',
    CREATE_INTEGRATION_PENDING = 'set up initial application configuration',
    SAVE_INTEGRATION_TASK = 'modified attributes mappings',
    EDIT_INTEGRATION_TASK = 'modified attributes mappings',
    DELETE_INTEGRATION_TASK = 'deleted entity mappings ',
    SAVE_INTEGRATION_ORG_MAPPING = 'modified schools mapping ',
    DELETE_INTEGRATION_ORG_MAPPING = 'deleted schools mapping item',
    BULK_DELETE_INTEGRATION_ORGS_MAPPING = 'deleted schools mapping in bulk',
    CREATE_OR_UPDATE_FTP_USER = 'created or modified SFTP user',
    DELETE_FTP_USER = 'deleted SFTP user',
    CREATE_DATA_SOURCE_CONFIG = 'completed initial delivery config setup',
    GENERATE_SECRET_KEY_SFTP = 'generated SFTP Secret Key',
    GENERATE_KEYS_LTI = 'generated LTI credentials',
    UPDATE_DATA_SOURCE_CONFIG = 'modified Delivery Config ',
    SAVE_MAPPING_RULES_ARCHIVE_OU = 'set Archive OU',
    CREATE_SHARED_POOL = 'created Shared Pool',
    APPLICATION_INSTITUTION_CREDENTIALS = 'accessed API credentials',
    ONBOARDING_INSTITUTION_CREDENTIALS = 'accessed onboarding API credentials',
    ONBOARDING_REGENERATE_INSTITUTION_CREDENTIALS = 'regenerate onboarding API credentials',
    SHARED_POOL_INSTITUTION_CREDENTIALS = 'accessed shared pool API Credentials',
    AUTH_API_TOKEN_SUCCESS = 'Successful API authentication',
    AUTH_API_TOKEN_EXCEEDED_FAILED_ATTEMPTS = 'Failed API authentication: Max number of attempts exceeded',
    AUTH_API_TOKEN_CLIENT_NOT_FOUND = 'Failed API authentication: Incorrect Client ID',
    AUTH_API_TOKEN_BAD_CREDENTIAL = 'Failed API authentication: Incorrect Client Secret',
    AUTH_LOGIN_SUCCESS = 'successfully logged in',
    AUTH_LOGIN_FAIL_BAD_USERNAME = 'failed to log in: Incorrect username',
    AUTH_LOGIN_FAIL_BAD_CREDENTIAL = 'failed to log in: Incorrect password',
    AUTH_LOGIN_FROM_ETX = 'successfully logged in from SchoolDay',
    USER_CHANGE_PASSWORD = 'reset password',
    SEND_LINK_FOR_RESET_PASSWORD = 'sent password reset link',
    MFA_REGENERATE_RESET_CODES = 'regenerated MFA recovery codes'
}

export const AuditUserActivityPrefixlessActions = {
    AUTH_API_TOKEN_SUCCESS: true,
    AUTH_API_TOKEN_EXCEEDED_FAILED_ATTEMPTS: true,
    AUTH_API_TOKEN_CLIENT_NOT_FOUND: true,
    AUTH_API_TOKEN_BAD_CREDENTIAL: true
};

export const AuditUserActivitySuffixlessActions = {
    AUTH_API_TOKEN_SUCCESS: true,
    AUTH_API_TOKEN_EXCEEDED_FAILED_ATTEMPTS: true,
    AUTH_API_TOKEN_CLIENT_NOT_FOUND: true,
    AUTH_API_TOKEN_BAD_CREDENTIAL: true,
    AUTH_LOGIN_SUCCESS: true,
    AUTH_LOGIN_FAIL_BAD_USERNAME: true,
    AUTH_LOGIN_FAIL_BAD_CREDENTIAL: true,
    AUTH_LOGIN_FROM_ETX: true,
    USER_CHANGE_PASSWORD: true,
    MFA_REGENERATE_RESET_CODES: true,
    SEND_LINK_FOR_RESET_PASSWORD: true,
};

export enum AuditUserActivityActionFriendlyTitles {
    SEND_REQUEST_WITH_INTEGRATION = 'Send data access consent',
    APPROVE_REQUEST = 'Approve data access consent',
    REJECT_REQUEST = 'Reject data access consent',
    DELETE_REQUEST = 'Delete data access consent',
    SAVE_EXPIRATION_DATE = 'Modify expiration time',
    CREATE_OR_UPDATE_APPLICATION = 'Create or updated application',
    DELETE_APPLICATION = 'Delete application',
    PUBLISH_UNPUBLISH_APPLICATION = 'Publish or unpublish application',
    SAVE_INTEGRATION_RULES = 'Modify data requirements or filter rules, or specific app`s settings (mapping rules or login credentials)',
    SAVE_INTEGRATION_PROCESS_CONFIG = 'Modify Sync Schedule',
    SAVE_DICTIONARY_BY_NAME = 'Modify specific application mappings',
    SAVE_QWIKLABS_DICTIONARY = 'Modify Qwiklabs courses and/or classes mappings',
    SAVE_APP_LINK_DICTIONARIES = 'Save SSO applications',
    RUN_SYNC = 'Run sync',
    SUSPEND_SYNC = 'Suspend sync',
    UNSUSPEND_SYNC = 'Resume sync',
    ACTIVATE_DISTRICT_FEATURE_TOGGLES = 'Modify district Advanced Settings ',
    ACTIVATE_APPLICATION_FEATURE_TOGGLES = 'Modify application Advanced Settings',
    ACTIVATE_INTEGRATION_FEATURE_TOGGLES = 'Modify application Advanced Settings',
    CREATE_ORGANIZATION = 'Create organization',
    EDIT_ORGANIZATION = 'Modify organization',
    DELETE_ORGANIZATION = 'Delete organization',
    ADD_ORGANIZATION_ADMIN = 'Create organization admin',
    EDIT_ORGANIZATION_ADMINS = 'Modify organization admin',
    DELETE_ORGANIZATION_ADMIN = 'Delete organization admin',
    DISABLE_MFA = 'Deactivate SMS MFA',
    DISABLE_TOTP_MFA = 'Deactivate TOTP MFA',
    CREATE_INTEGRATION = 'Set up initial application configuration',
    CREATE_INTEGRATION_PENDING = 'Set up initial application configuration',
    SAVE_INTEGRATION_TASK = 'Modify attributes mappings',
    EDIT_INTEGRATION_TASK = 'Modify attributes mappings',
    DELETE_INTEGRATION_TASK = 'Delete entity mappings ',
    SAVE_INTEGRATION_ORG_MAPPING = 'Modify schools mapping ',
    DELETE_INTEGRATION_ORG_MAPPING = 'Delete schools mapping item',
    BULK_DELETE_INTEGRATION_ORGS_MAPPING = 'Delete schools mapping in bulk',
    CREATE_OR_UPDATE_FTP_USER = 'Create or modify SFTP user',
    DELETE_FTP_USER = 'Delete SFTP user',
    CREATE_DATA_SOURCE_CONFIG = 'Complete initial delivery config setup',
    GENERATE_SECRET_KEY_SFTP = 'Generate SFTP Secret Key',
    GENERATE_KEYS_LTI = 'Generate LTI credentials',
    UPDATE_DATA_SOURCE_CONFIG = 'Modify Delivery Config ',
    SAVE_MAPPING_RULES_ARCHIVE_OU = 'Set Archive OU',
    CREATE_SHARED_POOL = 'Create Shared Pool',
    APPLICATION_INSTITUTION_CREDENTIALS = 'Access API credentials',
    ONBOARDING_INSTITUTION_CREDENTIALS = 'Access onboarding API credentials',
    ONBOARDING_REGENERATE_INSTITUTION_CREDENTIALS = 'Regenerate onboarding API credentials',
    SHARED_POOL_INSTITUTION_CREDENTIALS = 'Access shared pool API Credentials',
    AUTH_API_TOKEN_SUCCESS = 'Successful API authentication',
    AUTH_API_TOKEN_EXCEEDED_FAILED_ATTEMPTS = 'Failed API authentication: Max number of attempts exceeded',
    AUTH_API_TOKEN_CLIENT_NOT_FOUND = 'Failed API authentication: Incorrect Client ID',
    AUTH_API_TOKEN_BAD_CREDENTIAL = 'Failed API authentication: Incorrect Client Secret',
    AUTH_LOGIN_SUCCESS = 'Successful log in',
    AUTH_LOGIN_FAIL_BAD_USERNAME = 'Failed to log in: Incorrect username',
    AUTH_LOGIN_FAIL_BAD_CREDENTIAL = 'Failed to log in: Incorrect password',
    AUTH_LOGIN_FROM_ETX = 'Successful log in from SchoolDay',
    USER_CHANGE_PASSWORD = 'Reset password',
    SEND_LINK_FOR_RESET_PASSWORD = 'Send password reset link',
    MFA_REGENERATE_RESET_CODES = 'Regenerate MFA recovery codes'
}

export enum AuditUserActivityPagesList {
    ADMINISTRATION_ORGS_TAB_FOR_SYS_ADMIN = 'Administration Orgs tab for SysAdm',
    ADMINISTRATION_EDIT_ORG = 'Administration Edit Org',
    ADMINISTRATION_MAIN_ADMINS_TAB = 'Administration main Admins tab',
    DISTRICT_APP_ADMIN_PRIVATE = 'District App Admin Private',
    DISTRICT_APP_ADMIN_PUBLIC = 'District App Admin Public',
    APPLICATION_SETTINGS = 'Application settings',
    ADMINISTRATION_EDIT_DISTRICT_ADMIN = 'Administration District Edit Admin',
    ADMINISTRATION_EDIT_VENDOR_ADMIN = 'Administration Vendor Edit Admin',
    ADMINISTRATION_EDIT_SYS_ADMIN = 'Administration Edit Sys Admin',
    ADMINISTRATION_EDIT_SOME_ADMIN = 'Administration Edit Admin',
    NONE = 'none'
}

export const AuditUserActivityViewConfig = {
    [AuditUserActivityPagesList.ADMINISTRATION_ORGS_TAB_FOR_SYS_ADMIN]: {'orgLink': ['orgGuid'], 'userLink': ['userEmail', 'objectId']},
    [AuditUserActivityPagesList.ADMINISTRATION_EDIT_ORG]: {'userLink': ['userEmail', 'objectId']},
    [AuditUserActivityPagesList.ADMINISTRATION_MAIN_ADMINS_TAB]: {'userLink': ['userEmail', 'objectId']},
    [AuditUserActivityPagesList.DISTRICT_APP_ADMIN_PRIVATE]: {'userLink': ['userEmail']},
    [AuditUserActivityPagesList.DISTRICT_APP_ADMIN_PUBLIC]: {'userLink': ['userEmail']},
    [AuditUserActivityPagesList.APPLICATION_SETTINGS]: {'userLink': ['userEmail']},
    [AuditUserActivityPagesList.ADMINISTRATION_EDIT_DISTRICT_ADMIN]: {'userLink': ['objectId'], 'privateAppLink': ['districtGuid', 'appGuid'], 'publicAppLink': ['districtGuid', 'appGuid']},
    [AuditUserActivityPagesList.ADMINISTRATION_EDIT_VENDOR_ADMIN]: {'userLink': ['objectId'], 'draftAppLink': ['vendorGuid', 'appGuid'], 'publicAppLink': ['districtGuid', 'appGuid']},
    [AuditUserActivityPagesList.ADMINISTRATION_EDIT_SYS_ADMIN]: {'orgLink': ['orgGuid'], 'userLink': ['objectId'], 'draftAppLink': ['vendorGuid', 'appGuid'], 'privateAppLink': ['districtGuid', 'appGuid'], 'publicAppLink': ['districtGuid', 'appGuid']},
}

export const AuditUserActivityPageActionMap = {
    [AuditUserActivityPagesList.DISTRICT_APP_ADMIN_PRIVATE]: [
        AuditUserActivityActions.CREATE_INTEGRATION, // + <filter by integrationId>
        AuditUserActivityActions.RUN_SYNC, // + <filter by integrationId>
    ],
    [AuditUserActivityPagesList.DISTRICT_APP_ADMIN_PUBLIC]: [
        AuditUserActivityActions.SEND_REQUEST_WITH_INTEGRATION, // + <filter by integrationId>
        AuditUserActivityActions.APPROVE_REQUEST, // + <filter by integrationId>
        AuditUserActivityActions.REJECT_REQUEST, // + <filter by integrationId>
        AuditUserActivityActions.SAVE_EXPIRATION_DATE, // + <filter by integrationId>
        AuditUserActivityActions.DELETE_REQUEST, // + <filter by integrationId>
        AuditUserActivityActions.CREATE_INTEGRATION_PENDING, // + <filter by integrationId>
        AuditUserActivityActions.RUN_SYNC, // + <filter by integrationId>
        AuditUserActivityActions.SUSPEND_SYNC, // + <filter by integrationId>
        AuditUserActivityActions.UNSUSPEND_SYNC, // + <filter by integrationId>
        AuditUserActivityActions.APPLICATION_INSTITUTION_CREDENTIALS, // + <filter by institution and applicationGuid>
        AuditUserActivityActions.AUTH_API_TOKEN_SUCCESS, // + <filter by institution and applicationGuid>
        AuditUserActivityActions.AUTH_API_TOKEN_EXCEEDED_FAILED_ATTEMPTS, // + <filter by institution and applicationGuid>
        AuditUserActivityActions.AUTH_API_TOKEN_BAD_CREDENTIAL, // + <filter by institution and applicationGuid>
    ],
    [AuditUserActivityPagesList.APPLICATION_SETTINGS]: [
        AuditUserActivityActions.CREATE_OR_UPDATE_APPLICATION, // + <filter by applicationId>
        AuditUserActivityActions.PUBLISH_UNPUBLISH_APPLICATION, // + <filter by applicationId> !!!
        AuditUserActivityActions.CREATE_INTEGRATION, // + <filter by integrationId>
        AuditUserActivityActions.SAVE_INTEGRATION_TASK, // + <filter by integrationId>
        AuditUserActivityActions.EDIT_INTEGRATION_TASK, // + <filter by integrationId>
        AuditUserActivityActions.DELETE_INTEGRATION_TASK, // + <filter by integrationId>
        AuditUserActivityActions.SAVE_INTEGRATION_ORG_MAPPING, // + <filter by integrationId>
        AuditUserActivityActions.DELETE_INTEGRATION_ORG_MAPPING, // + <filter by integrationId> ???
        AuditUserActivityActions.BULK_DELETE_INTEGRATION_ORGS_MAPPING, // + <filter by integrationId> ???
        AuditUserActivityActions.SAVE_INTEGRATION_RULES, // + <filter by integrationId>
        AuditUserActivityActions.SAVE_INTEGRATION_PROCESS_CONFIG, // + <filter by integrationId>
        AuditUserActivityActions.SAVE_DICTIONARY_BY_NAME, // + <filter by integrationId>
        AuditUserActivityActions.SAVE_QWIKLABS_DICTIONARY, // + <filter by dname> ???
        AuditUserActivityActions.SAVE_APP_LINK_DICTIONARIES, // + <filter by dname>. Google Classroom saveAppLinkDictionaries ???
        AuditUserActivityActions.CREATE_DATA_SOURCE_CONFIG, // + <filter by dname>
        AuditUserActivityActions.GENERATE_SECRET_KEY_SFTP, // + <filter by dname>. (only in sftp) ???
        AuditUserActivityActions.GENERATE_KEYS_LTI, // + <filter by dname>
        AuditUserActivityActions.UPDATE_DATA_SOURCE_CONFIG, // + <filter by dname>
        AuditUserActivityActions.CREATE_SHARED_POOL, // + <filter by applicationGuid>
        AuditUserActivityActions.ACTIVATE_APPLICATION_FEATURE_TOGGLES, // + <filter by applicationGuid>
        AuditUserActivityActions.ACTIVATE_INTEGRATION_FEATURE_TOGGLES, // + <filter by integrationId>
        AuditUserActivityActions.SAVE_MAPPING_RULES_ARCHIVE_OU, // + <filter by dname>
        AuditUserActivityActions.CREATE_OR_UPDATE_FTP_USER, // + <filter by ftp user username>
        AuditUserActivityActions.DELETE_FTP_USER, // + <filter by ftp user username>
        AuditUserActivityActions.APPLICATION_INSTITUTION_CREDENTIALS, // + <filter by institution and applicationGuid>
        AuditUserActivityActions.ONBOARDING_INSTITUTION_CREDENTIALS, // + <filter by applicationGuid>
        AuditUserActivityActions.ONBOARDING_REGENERATE_INSTITUTION_CREDENTIALS, // + <filter by applicationGuid>
        AuditUserActivityActions.SHARED_POOL_INSTITUTION_CREDENTIALS, // + <filter by applicationGuid>
    ],
    [AuditUserActivityPagesList.ADMINISTRATION_ORGS_TAB_FOR_SYS_ADMIN]: [ // orgGuid == GG4L_ORG_ID:
        AuditUserActivityActions.CREATE_ORGANIZATION, // + <filter by orgGuid>
        AuditUserActivityActions.EDIT_ORGANIZATION, // + <filter by orgGuid>
        AuditUserActivityActions.DELETE_ORGANIZATION, // + <filter by orgGuid>
        AuditUserActivityActions.ACTIVATE_DISTRICT_FEATURE_TOGGLES, // + <filter by orgGuid>
        AuditUserActivityActions.ADD_ORGANIZATION_ADMIN, // no filter by objectId (user guid)
        AuditUserActivityActions.EDIT_ORGANIZATION_ADMINS, // no filter by objectId (user guid)
        AuditUserActivityActions.DELETE_ORGANIZATION_ADMIN, // no filter by objectId (user guid)
        AuditUserActivityActions.DISABLE_MFA, // no filter by objectId (user guid)
        AuditUserActivityActions.DISABLE_TOTP_MFA, // no filter by objectId (user guid)
    ],
    [AuditUserActivityPagesList.ADMINISTRATION_MAIN_ADMINS_TAB]: [ // (not for sub Orgs) + filter by orgGuid
        AuditUserActivityActions.ADD_ORGANIZATION_ADMIN, // + no filter by objectId (user guid)
        AuditUserActivityActions.EDIT_ORGANIZATION_ADMINS, // + no filter by objectId (user guid)
        AuditUserActivityActions.DELETE_ORGANIZATION_ADMIN, // + no filter by objectId (user guid)
        AuditUserActivityActions.DISABLE_MFA, // + no filter by objectId (user guid)
        AuditUserActivityActions.DISABLE_TOTP_MFA, // + no filter by objectId (user guid)
    ],
    [AuditUserActivityPagesList.ADMINISTRATION_EDIT_ORG]: [ // by selected Org (for all sub tabs) + filter by orgGuid
        AuditUserActivityActions.CREATE_ORGANIZATION, // + <filter by orgGuid>
        AuditUserActivityActions.EDIT_ORGANIZATION, // + <filter by orgGuid>
        AuditUserActivityActions.DELETE_ORGANIZATION, // + <filter by orgGuid>
        AuditUserActivityActions.ACTIVATE_DISTRICT_FEATURE_TOGGLES, // + <filter by orgGuid>
        AuditUserActivityActions.ADD_ORGANIZATION_ADMIN, // + no filter by objectId (user guid)
        AuditUserActivityActions.EDIT_ORGANIZATION_ADMINS, // + no filter by objectId (user guid)
        AuditUserActivityActions.DELETE_ORGANIZATION_ADMIN, // + no filter by objectId (user guid)
        AuditUserActivityActions.DISABLE_MFA, // + no filter by objectId (user guid)
        AuditUserActivityActions.DISABLE_TOTP_MFA, // + no filter by objectId (user guid)
    ],
    [AuditUserActivityPagesList.ADMINISTRATION_EDIT_VENDOR_ADMIN]: [ //  tab for not SysAdm orgGuid of current user's org
        AuditUserActivityActions.DELETE_APPLICATION, // + <filter by applicationId>
        AuditUserActivityActions.CREATE_INTEGRATION_PENDING, // + <filter by integrationId>
        AuditUserActivityActions.CREATE_INTEGRATION, // + <filter by integrationId>
        AuditUserActivityActions.RUN_SYNC, // + <filter by integrationId>
        AuditUserActivityActions.SEND_REQUEST_WITH_INTEGRATION, // + <filter by integrationId>
        AuditUserActivityActions.APPROVE_REQUEST, // + <filter by integrationId>
        AuditUserActivityActions.REJECT_REQUEST, // + <filter by integrationId>
        AuditUserActivityActions.SAVE_EXPIRATION_DATE, // + <filter by integrationId>
        AuditUserActivityActions.DELETE_REQUEST, // + <filter by integrationId>
        AuditUserActivityActions.SUSPEND_SYNC, // + <filter by integrationId>
        AuditUserActivityActions.UNSUSPEND_SYNC, // + <filter by integrationId>
        AuditUserActivityActions.APPLICATION_INSTITUTION_CREDENTIALS, // + <filter by institution and applicationGuid>
        AuditUserActivityActions.CREATE_ORGANIZATION, // + <filter by orgGuid>
        AuditUserActivityActions.EDIT_ORGANIZATION, // + <filter by orgGuid>
        AuditUserActivityActions.DELETE_ORGANIZATION, // + <filter by orgGuid>
        AuditUserActivityActions.ACTIVATE_DISTRICT_FEATURE_TOGGLES, // + <filter by orgGuid>
        AuditUserActivityActions.ADD_ORGANIZATION_ADMIN, // no filter by objectId (user guid)
        AuditUserActivityActions.EDIT_ORGANIZATION_ADMINS, // no filter by objectId (user guid)
        AuditUserActivityActions.DELETE_ORGANIZATION_ADMIN, // no filter by objectId (user guid)
        AuditUserActivityActions.DISABLE_MFA, // no filter by objectId (user guid)
        AuditUserActivityActions.DISABLE_TOTP_MFA, // no filter by objectId (user guid)
        AuditUserActivityActions.CREATE_OR_UPDATE_APPLICATION, // + <filter by applicationId>
        AuditUserActivityActions.PUBLISH_UNPUBLISH_APPLICATION, // + <filter by applicationId> !!!
        AuditUserActivityActions.CREATE_INTEGRATION, // + <filter by integrationId>
        AuditUserActivityActions.SAVE_INTEGRATION_TASK, // + <filter by integrationId>
        AuditUserActivityActions.EDIT_INTEGRATION_TASK, // + <filter by integrationId>
        AuditUserActivityActions.DELETE_INTEGRATION_TASK, // + <filter by integrationId>
        AuditUserActivityActions.SAVE_INTEGRATION_ORG_MAPPING, // + <filter by integrationId>
        AuditUserActivityActions.DELETE_INTEGRATION_ORG_MAPPING, // + <filter by integrationId> ???
        AuditUserActivityActions.BULK_DELETE_INTEGRATION_ORGS_MAPPING, // + <filter by integrationId> ???
        AuditUserActivityActions.SAVE_INTEGRATION_RULES, // + <filter by integrationId>
        AuditUserActivityActions.SAVE_INTEGRATION_PROCESS_CONFIG, // + <filter by integrationId>
        AuditUserActivityActions.SAVE_DICTIONARY_BY_NAME, // + <filter by integrationId>
        AuditUserActivityActions.SAVE_QWIKLABS_DICTIONARY, // + <filter by dname> ???
        AuditUserActivityActions.SAVE_APP_LINK_DICTIONARIES, // + <filter by dname>. Google Classroom saveAppLinkDictionaries ???
        AuditUserActivityActions.CREATE_DATA_SOURCE_CONFIG, // + <filter by dname>
        AuditUserActivityActions.GENERATE_SECRET_KEY_SFTP, // + <filter by dname>. (only in sftp) ???
        AuditUserActivityActions.GENERATE_KEYS_LTI, // + <filter by dname>
        AuditUserActivityActions.UPDATE_DATA_SOURCE_CONFIG, // + <filter by dname>
        AuditUserActivityActions.CREATE_SHARED_POOL, // + <filter by applicationGuid>
        AuditUserActivityActions.ACTIVATE_APPLICATION_FEATURE_TOGGLES, // + <filter by applicationGuid>
        AuditUserActivityActions.ACTIVATE_INTEGRATION_FEATURE_TOGGLES, // + <filter by integrationId>
        AuditUserActivityActions.SAVE_MAPPING_RULES_ARCHIVE_OU, // + <filter by dname>
        AuditUserActivityActions.CREATE_OR_UPDATE_FTP_USER, // + <filter by ftp user username>
        AuditUserActivityActions.DELETE_FTP_USER, // + <filter by ftp user username>
        AuditUserActivityActions.ONBOARDING_INSTITUTION_CREDENTIALS, // + <filter by applicationGuid>
        AuditUserActivityActions.ONBOARDING_REGENERATE_INSTITUTION_CREDENTIALS, // + <filter by applicationGuid>
        AuditUserActivityActions.SHARED_POOL_INSTITUTION_CREDENTIALS, // + <filter by applicationGuid>
        AuditUserActivityActions.AUTH_LOGIN_SUCCESS, // + <filter by username>
        AuditUserActivityActions.AUTH_LOGIN_FAIL_BAD_CREDENTIAL, // + <filter by username>
        AuditUserActivityActions.AUTH_LOGIN_FROM_ETX, // + <filter by username>
        AuditUserActivityActions.USER_CHANGE_PASSWORD, // + <filter by email>
        AuditUserActivityActions.SEND_LINK_FOR_RESET_PASSWORD, // + <filter by email>
        AuditUserActivityActions.MFA_REGENERATE_RESET_CODES // + <filter by email>
    ],
    [AuditUserActivityPagesList.ADMINISTRATION_EDIT_DISTRICT_ADMIN]: [], // same all actions as for AuditUserActivityPagesList.ADMINISTRATION_EDIT_VENDOR_ADMIN
    [AuditUserActivityPagesList.ADMINISTRATION_EDIT_SYS_ADMIN]: [], // same all actions as for AuditUserActivityPagesList.ADMINISTRATION_EDIT_VENDOR_ADMIN
    ['none']: [
        AuditUserActivityActions.AUTH_API_TOKEN_CLIENT_NOT_FOUND, // + <filter by clientId>  // ToDo: Need to decide where to show this action ???
        AuditUserActivityActions.AUTH_LOGIN_FAIL_BAD_USERNAME, // + <filter by email> // ToDo: Need to decide where to show this action ???
    ]
};
AuditUserActivityPageActionMap[AuditUserActivityPagesList.ADMINISTRATION_EDIT_DISTRICT_ADMIN] =
    AuditUserActivityPageActionMap[AuditUserActivityPagesList.ADMINISTRATION_EDIT_VENDOR_ADMIN];
AuditUserActivityPageActionMap[AuditUserActivityPagesList.ADMINISTRATION_EDIT_SYS_ADMIN] =
    AuditUserActivityPageActionMap[AuditUserActivityPagesList.ADMINISTRATION_EDIT_VENDOR_ADMIN];

export const AuditUserActivityActionRelatedPagesMap: {[key: string]: AuditUserActivityPagesList} = {
    [AuditUserActivityActions.SEND_REQUEST_WITH_INTEGRATION]: AuditUserActivityPagesList.DISTRICT_APP_ADMIN_PUBLIC, // + <filter by integrationId>
    [AuditUserActivityActions.APPROVE_REQUEST]: AuditUserActivityPagesList.DISTRICT_APP_ADMIN_PUBLIC, // + <filter by integrationId>
    [AuditUserActivityActions.REJECT_REQUEST]: AuditUserActivityPagesList.DISTRICT_APP_ADMIN_PUBLIC, // + <filter by integrationId>
    [AuditUserActivityActions.DELETE_REQUEST]: AuditUserActivityPagesList.DISTRICT_APP_ADMIN_PUBLIC, // + <filter by integrationId>
    [AuditUserActivityActions.SAVE_EXPIRATION_DATE]: AuditUserActivityPagesList.DISTRICT_APP_ADMIN_PUBLIC, // + <filter by integrationId>
    [AuditUserActivityActions.RUN_SYNC]: AuditUserActivityPagesList.DISTRICT_APP_ADMIN_PUBLIC, // + <filter by integrationId>
    [AuditUserActivityActions.SUSPEND_SYNC]: AuditUserActivityPagesList.DISTRICT_APP_ADMIN_PUBLIC, // + <filter by integrationId>
    [AuditUserActivityActions.UNSUSPEND_SYNC]: AuditUserActivityPagesList.DISTRICT_APP_ADMIN_PUBLIC, // + <filter by integrationId>
    [AuditUserActivityActions.CREATE_INTEGRATION_PENDING]: AuditUserActivityPagesList.DISTRICT_APP_ADMIN_PUBLIC, // + <filter by integrationId>
    [AuditUserActivityActions.APPLICATION_INSTITUTION_CREDENTIALS]: AuditUserActivityPagesList.DISTRICT_APP_ADMIN_PUBLIC, // + <filter by institution and applicationGuid>
    [AuditUserActivityActions.AUTH_API_TOKEN_SUCCESS]: AuditUserActivityPagesList.DISTRICT_APP_ADMIN_PUBLIC, // + <filter by institution and applicationGuid>
    [AuditUserActivityActions.AUTH_API_TOKEN_EXCEEDED_FAILED_ATTEMPTS]: AuditUserActivityPagesList.DISTRICT_APP_ADMIN_PUBLIC, // + <filter by institution and applicationGuid>
    [AuditUserActivityActions.AUTH_API_TOKEN_BAD_CREDENTIAL]: AuditUserActivityPagesList.DISTRICT_APP_ADMIN_PUBLIC, // + <filter by institution and applicationGuid>

    [AuditUserActivityActions.CREATE_OR_UPDATE_APPLICATION]: AuditUserActivityPagesList.APPLICATION_SETTINGS,
    [AuditUserActivityActions.DELETE_APPLICATION]: AuditUserActivityPagesList.APPLICATION_SETTINGS,
    [AuditUserActivityActions.PUBLISH_UNPUBLISH_APPLICATION]: AuditUserActivityPagesList.APPLICATION_SETTINGS,
    [AuditUserActivityActions.SAVE_INTEGRATION_RULES]: AuditUserActivityPagesList.APPLICATION_SETTINGS,
    [AuditUserActivityActions.SAVE_INTEGRATION_PROCESS_CONFIG]: AuditUserActivityPagesList.APPLICATION_SETTINGS,
    [AuditUserActivityActions.SAVE_DICTIONARY_BY_NAME]: AuditUserActivityPagesList.APPLICATION_SETTINGS,
    [AuditUserActivityActions.SAVE_QWIKLABS_DICTIONARY]: AuditUserActivityPagesList.APPLICATION_SETTINGS,
    [AuditUserActivityActions.SAVE_APP_LINK_DICTIONARIES]: AuditUserActivityPagesList.APPLICATION_SETTINGS,
    [AuditUserActivityActions.CREATE_INTEGRATION]: AuditUserActivityPagesList.APPLICATION_SETTINGS,
    [AuditUserActivityActions.SAVE_INTEGRATION_TASK]: AuditUserActivityPagesList.APPLICATION_SETTINGS,
    [AuditUserActivityActions.EDIT_INTEGRATION_TASK]: AuditUserActivityPagesList.APPLICATION_SETTINGS,
    [AuditUserActivityActions.DELETE_INTEGRATION_TASK]: AuditUserActivityPagesList.APPLICATION_SETTINGS,
    [AuditUserActivityActions.SAVE_INTEGRATION_ORG_MAPPING]: AuditUserActivityPagesList.APPLICATION_SETTINGS,
    [AuditUserActivityActions.DELETE_INTEGRATION_ORG_MAPPING]: AuditUserActivityPagesList.APPLICATION_SETTINGS,
    [AuditUserActivityActions.BULK_DELETE_INTEGRATION_ORGS_MAPPING]: AuditUserActivityPagesList.APPLICATION_SETTINGS,
    [AuditUserActivityActions.CREATE_OR_UPDATE_FTP_USER]: AuditUserActivityPagesList.APPLICATION_SETTINGS,
    [AuditUserActivityActions.DELETE_FTP_USER]: AuditUserActivityPagesList.APPLICATION_SETTINGS,
    [AuditUserActivityActions.CREATE_DATA_SOURCE_CONFIG]: AuditUserActivityPagesList.APPLICATION_SETTINGS,
    [AuditUserActivityActions.GENERATE_SECRET_KEY_SFTP]: AuditUserActivityPagesList.APPLICATION_SETTINGS,
    [AuditUserActivityActions.GENERATE_KEYS_LTI]: AuditUserActivityPagesList.APPLICATION_SETTINGS,
    [AuditUserActivityActions.UPDATE_DATA_SOURCE_CONFIG]: AuditUserActivityPagesList.APPLICATION_SETTINGS,
    [AuditUserActivityActions.SAVE_MAPPING_RULES_ARCHIVE_OU]: AuditUserActivityPagesList.APPLICATION_SETTINGS,
    [AuditUserActivityActions.CREATE_SHARED_POOL]: AuditUserActivityPagesList.APPLICATION_SETTINGS,
    [AuditUserActivityActions.ONBOARDING_INSTITUTION_CREDENTIALS]: AuditUserActivityPagesList.APPLICATION_SETTINGS,
    [AuditUserActivityActions.ONBOARDING_REGENERATE_INSTITUTION_CREDENTIALS]: AuditUserActivityPagesList.APPLICATION_SETTINGS,
    [AuditUserActivityActions.SHARED_POOL_INSTITUTION_CREDENTIALS]: AuditUserActivityPagesList.APPLICATION_SETTINGS,
    [AuditUserActivityActions.ACTIVATE_APPLICATION_FEATURE_TOGGLES]: AuditUserActivityPagesList.APPLICATION_SETTINGS,
    [AuditUserActivityActions.ACTIVATE_INTEGRATION_FEATURE_TOGGLES]: AuditUserActivityPagesList.APPLICATION_SETTINGS,

    [AuditUserActivityActions.ACTIVATE_DISTRICT_FEATURE_TOGGLES]: AuditUserActivityPagesList.ADMINISTRATION_EDIT_ORG,
    [AuditUserActivityActions.CREATE_ORGANIZATION]: AuditUserActivityPagesList.ADMINISTRATION_EDIT_ORG,
    [AuditUserActivityActions.EDIT_ORGANIZATION]: AuditUserActivityPagesList.ADMINISTRATION_EDIT_ORG,
    [AuditUserActivityActions.DELETE_ORGANIZATION]: AuditUserActivityPagesList.ADMINISTRATION_EDIT_ORG,

    [AuditUserActivityActions.ADD_ORGANIZATION_ADMIN]: AuditUserActivityPagesList.ADMINISTRATION_EDIT_SOME_ADMIN,
    [AuditUserActivityActions.EDIT_ORGANIZATION_ADMINS]: AuditUserActivityPagesList.ADMINISTRATION_EDIT_SOME_ADMIN,
    [AuditUserActivityActions.DELETE_ORGANIZATION_ADMIN]: AuditUserActivityPagesList.ADMINISTRATION_EDIT_SOME_ADMIN,
    [AuditUserActivityActions.DISABLE_MFA]: AuditUserActivityPagesList.ADMINISTRATION_EDIT_SOME_ADMIN,
    [AuditUserActivityActions.DISABLE_TOTP_MFA]: AuditUserActivityPagesList.ADMINISTRATION_EDIT_SOME_ADMIN,
    [AuditUserActivityActions.AUTH_LOGIN_SUCCESS]: AuditUserActivityPagesList.ADMINISTRATION_EDIT_SOME_ADMIN,
    [AuditUserActivityActions.AUTH_LOGIN_FAIL_BAD_CREDENTIAL]: AuditUserActivityPagesList.ADMINISTRATION_EDIT_SOME_ADMIN,
    [AuditUserActivityActions.AUTH_LOGIN_FROM_ETX]: AuditUserActivityPagesList.ADMINISTRATION_EDIT_SOME_ADMIN,
    [AuditUserActivityActions.USER_CHANGE_PASSWORD]: AuditUserActivityPagesList.ADMINISTRATION_EDIT_SOME_ADMIN,
    [AuditUserActivityActions.SEND_LINK_FOR_RESET_PASSWORD]: AuditUserActivityPagesList.ADMINISTRATION_EDIT_SOME_ADMIN,
    [AuditUserActivityActions.MFA_REGENERATE_RESET_CODES]: AuditUserActivityPagesList.ADMINISTRATION_EDIT_SOME_ADMIN,

    [AuditUserActivityActions.AUTH_LOGIN_FAIL_BAD_USERNAME]: AuditUserActivityPagesList.NONE, // ToDo: Need to decide where to show this action ???
    [AuditUserActivityActions.AUTH_API_TOKEN_CLIENT_NOT_FOUND]: AuditUserActivityPagesList.NONE, // ToDo: Need to decide where to show this action ???
};


export const AUDIT_USER_ACTION_OBJECT_ID_DELIMITER = '|';
